import { Button, Divider } from '@mui/material';
import React, { memo } from 'react';
import { t } from 'i18next';

import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useNotification from 'hooks/useNotification';

export default memo(function AcceptAction({ id, refetch }) {
  const sendNotification = useNotification();
  const axiosPrivate = useAxiosPrivate();
  const onSubmit = async () => {
    try {
      let response = await axiosPrivate.post(`/crm/crm-lead/accept/${id}`, {
        headers: { 'Content-Type': 'application/json' },
      });
      if (response && response.data && response.data.status) {
        refetch?.();
        sendNotification({
          msg: response?.data?.message || response?.message,
          variant: 'success',
        });
      }
    } catch (error) {
      sendNotification({
        msg: error?.response?.data?.message || error?.message,
        variant: 'error',
      });
    }
  };
  return (
    <div
      className='w-0 absolute transition-all origin-right right-0 top-0 group-hover:w-32 backdrop-blur-xl rounded-r-sm overflow-hidden h-full'
      style={{
        background:
          'linear-gradient(0deg, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0.8)), linear-gradient(0deg, rgba(193, 193, 193, 0.2), rgba(193, 193, 193, 0.2))',
      }}
    >
      <Button
        fullWidth
        size='small'
        className='!rounded-none whitespace-nowrap !justify-start !pl-2 !h-1/2 !text-[#494C5C]'
        startIcon={<i className='bi bi-check !leading-4 text-green-500' />}
        onClick={onSubmit}
      >
        {t('common.button.acceptance')}
      </Button>
      <Divider className='!mx-2' />
      <Button
        fullWidth
        size='small'
        className='!rounded-none whitespace-nowrap !justify-start !pl-2 !h-1/2 !text-[#494C5C]'
        startIcon={<i className='bi bi-x !leading-4 text-red-500' />}
      >
        {t('common.button.cancel')}
      </Button>
    </div>
  );
});
